module.exports = __webpack_public_path__ + "img/sex_worker.4b54eb8e.jpeg";